export default "__VITE_ASSET__M4LY$3Y5__"